import legalContent from "../legal-content.json";

function Address() {
  const provider = legalContent.provider;
  return (
    <p>
      <strong>{provider.legalName}</strong><br />
      Geschäftsführer: {provider.representative}<br />
      {provider.street}<br />
      {provider.postalCode} {provider.city}<br />
      {provider.country}
    </p>
  );
}

function Registration() {
  const provider = legalContent.provider;
  return (
    <p>
      Firmenbuchnummer: {provider.registryNumber}<br />
      Zuständiges Gericht: {provider.registryCourt}<br />
      UID-Nummer: {provider.vatId}
    </p>
  );
}

function Email() {
  const email = legalContent.provider.email;
  return <p>E-Mail: <a href={`mailto:${email}`}>{email}</a></p>;
}

export function LegalContent({ type }: { type: "imprint" | "privacy" }) {
  if (type === "imprint") {
    const imprint = legalContent.imprint;
    return (
      <>
        <section><h2>{imprint.providerHeading}</h2><Address /><Registration /></section>
        <section><h2>{imprint.contactHeading}</h2><Email /></section>
        <section><h2>{imprint.purposeHeading}</h2><p>{legalContent.businessPurpose}</p></section>
        <section><h2>{imprint.liabilityHeading}</h2><p>{imprint.liability}</p></section>
      </>
    );
  }

  const privacy = legalContent.privacy;
  return (
    <>
      <section><h2>{privacy.controllerHeading}</h2><Address /><Email /></section>
      <section><h2>{privacy.hostingHeading}</h2>{privacy.hosting.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</section>
      <section><h2>{privacy.marketplaceHeading}</h2>{privacy.marketplace.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</section>
      <section><h2>{privacy.cookiesHeading}</h2><p>{privacy.cookies}</p></section>
      <section><h2>{privacy.rightsHeading}</h2><p>{privacy.rights}</p></section>
      <section><h2>{privacy.effectiveHeading}</h2><p>{privacy.effectiveDate}</p></section>
    </>
  );
}

export function legalPageMetadata(type: "imprint" | "privacy") {
  const page = type === "imprint" ? legalContent.imprint : legalContent.privacy;
  return { eyebrow: page.eyebrow, title: page.title };
}

export { legalContent };
